export const cornerDetectionUrl =
    "https://receipt.justsnap.de/getConvertedImageWithPoints";

export const DOM_HTML = `    
<div class="receipt-uploader">
      <div class="row">
        <div class="">
          <div class="left_block">
            <span class="control-btn btn-crop">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-crop"
              >
                <path d="M6.13 1L6 16a2 2 0 0 0 2 2h15"></path>
                <path d="M1 6.13L16 6a2 2 0 0 1 2 2v15"></path>
              </svg>
            </span>
            <span class="control-btn btn-pen">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-edit-2"
              >
                <path
                  d="M17 3a2.828 2.828 0 1 1 4 4L7.5 20.5 2 22l1.5-5.5L17 3z"
                ></path>
              </svg>
            </span>
            <span class="control-btn btn-pan">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-move"
              >
                <polyline points="5 9 2 12 5 15"></polyline>
                <polyline points="9 5 12 2 15 5"></polyline>
                <polyline points="15 19 12 22 9 19"></polyline>
                <polyline points="19 9 22 12 19 15"></polyline>
                <line x1="2" y1="12" x2="22" y2="12"></line>
                <line x1="12" y1="2" x2="12" y2="22"></line>
              </svg>
            </span>
            <span class="control-btn btn-zoom-in">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-zoom-in"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="11" y1="8" x2="11" y2="14"></line>
                <line x1="8" y1="11" x2="14" y2="11"></line>
              </svg>
            </span>
            <span class="control-btn btn-zoom-out">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
                class="feather feather-zoom-out"
              >
                <circle cx="11" cy="11" r="8"></circle>
                <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                <line x1="8" y1="11" x2="14" y2="11"></line>
              </svg>
            </span>
          </div>
          <div class="">
            <div class="right_block swipper_bottom">
              <div class="canvas-container">
                <canvas id="CropCanvas"></canvas>
                <canvas id="ImageDisplayer"></canvas>
                <canvas id="OriginalCanvas" height="1000" width="1000"></canvas>
                <canvas id="ResultCanvas"></canvas>
              </div>
              <div id="loader" class="loader-wrapper">
                <div class="scanner">
                  <div class="invoice"></div>
                  <div class="scanner-bar"></div>
                </div>
                <div class="text">
                  <p class="desc_1" id="receiptPhrase1">receiptPhrase1</p>
                  <p class="desc_2" id="receiptPhrase2">receiptPhrase2</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
`